<po-page-list #poPageListComponent
  p-title="Pedido de Venda - Lista"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>

</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-lookup
      class="po-md-6"
      p-label="Guarita"
      name="CC5GUARITA"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CC5GUARITA"
      p-field-value="CZPRCHAVE"
      p-field-label="CZPRGENERI"
      [p-columns]="guaritaColumnsFilters"
      [p-field-format]="guaritaFieldFormaterFilters"
      [p-filter-service]="zprLookupService"
      [p-advanced-filters]="guaritaAdvancedFilters"
      [p-literals]="{ modalTitle: 'Guarita' }"
      [p-required]="true"
    ></po-lookup>
    <po-datepicker
      class="po-md-6"
      name="DC5EMISSAO_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC5EMISSAO_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data de"
    ></po-datepicker>
    <po-datepicker
      class="po-md-6"
      name="DC5EMISSAO_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC5EMISSAO_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data até"
    ></po-datepicker>
    <po-input
      class="po-md-6"
      name="CC5NUM"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CC5NUM"
      p-label="Código Pedido"
      [p-maxlength]="6"
    ></po-input>
  </form>
</po-modal>

<po-modal
  #listaTitulosModal
  p-title="Lista Títulos em Aberto"
  p-size="lg"
>
  <po-table class="po-sm-12 po-md-12 po-lg-12 po-mb-3"
    [p-height]="400"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="colunasTitulos"
    [p-items]="listaTitulosCliente.items"
    p-spacing="small"
  ></po-table>
  <po-info p-label="Saldo total" p-value="{{valorTotalTitulos| currency : 'BRL'}}"> </po-info>
</po-modal>
